export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "buttons": {
          "end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End call"])},
          "transfer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer"])}
        },
        "hintForDisabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have reached the limit of 50 active calls. To make a new call, please end one of the existing ones."])}
      },
      "ru": {
        "buttons": {
          "end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завершить"])},
          "transfer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевести"])}
        },
        "hintForDisabled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Превышен лимит в 50 активных звонков. Для совершения нового звонка, пожалуйста, завершите один из существующих звонков."])}
      }
    }
  })
}
